import styled from 'styled-components';
import { withTheme } from '@material-ui/core';

export const StyledHour = withTheme(styled('div')`
  line-height: ${(props) => props.lineHeight}px;
  color: ${({ theme }) => theme.palette.common.black};
`);
